import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const AuxiliarManager = (props) => {
  const { readOnly, existingReservation, isModified } = props;

  const iconClass = (existingReservation) ? 'icon-reload' : 'icon-eliminar';
  const dataTestId = (existingReservation) ? 'boton-revertir-cambios' : 'boton-eliminar-reserva';

  const handleContainerClasses = () => {
    let finalClass = '';

    if (!existingReservation) finalClass = 'delete-icon';

    if (!isModified) finalClass = `${finalClass} dirty-prevent`;

    return finalClass;
  };

  const handleAction = () => {
    if (existingReservation) {
      props.handleRevertDataAction();
      return;
    }

    props.handleDeleteAction();
  };

  return (
    <>
      {(!readOnly) &&
        <span className={handleContainerClasses()}>
          <Button
            className="icon-button"
            data-test-id={dataTestId}
            onClick={handleAction}
          >
            <span className={iconClass} />
          </Button>
        </span>
      }
    </>
  );
};

AuxiliarManager.propTypes = {
  readOnly: PropTypes.bool,
  existingReservation: PropTypes.bool,
  isModified: PropTypes.bool,
  handleDeleteAction: PropTypes.func,
  handleRevertDataAction: PropTypes.func
};

AuxiliarManager.defaultProps = {
  readOnly: false,
  existingReservation: false,
  isModified: false,
  handleDeleteAction: () => {},
  handleRevertDataAction: () => {}
};

export default AuxiliarManager;
